// export const changeIsLogin = state => state.isLogin
// export const userInformation = state => state.userInfo
// export const userAccount = state => state.Account
// export const userLevelInfo = state => state.userLevel
// export const token = state => state.token
// export const key = state => state.key
export default {
//  isLoginShow (state) {
//    return state.isLoginShow
//  }
}



// WEBPACK FOOTER //
// ./src/store/getters/getters.js